import { z } from 'zod';
import { BODY_FORMATS } from '../lib/body';

export const createTemplateSchema = z.object({
  name: z.string().min(1).max(100),
  /** Null applies the template to every category. */
  category: z.string().max(100).nullable().optional(),
  subject: z.string().min(1).max(255),
  /** Plain text, or sanitized HTML when `bodyFormat` says so. The ceiling is
   *  higher than the old plain-text one because markup is not free — an HTML
   *  body is the same prose carrying its own paragraph tags. Images cost
   *  nothing here: they are stored bytes referenced by a short URL. */
  body: z.string().min(1).max(60000),
  bodyFormat: z.enum(BODY_FORMATS).default('text'),
  /** Rotated across a batch so ten messages are not byte-identical (PRD §F3). */
  openingVariants: z.array(z.string().min(1).max(500)).max(10).default([]),
  isDefault: z.boolean().default(false),
});

export const updateTemplateSchema = createTemplateSchema.partial();

export type CreateTemplateInput = z.infer<typeof createTemplateSchema>;
export type UpdateTemplateInput = z.infer<typeof updateTemplateSchema>;
